import * as React from 'react';
import { ChartData, ChartDataContext } from "../context/Chart";
import { generateRandomRgb } from "../util/color";
import { BarChart } from "./BarChart";

const convertResultsetToChartData = (data: ChartData, colors: string[]) => {

    return data.result_set.map(rs => {
        return {
            label: rs.title,
            result_set: rs.chapter.map((chapter,index) => {
                return {
                    chapter: chapter.title,
                    dataset: {
                        labels: chapter.question.map(function (question) {
                            return question.title;
                        }),
                        datasets: rs.result.map((resultSet, idx) => {
                            return {
                                label: resultSet.title,
                                data : rs.chapter[index].question.map( function ( q ) {
                                    const r = q.answer.filter(answer => {
                                        return answer.abbr === resultSet.abbr;
                                    });

                                    if(r.length > 0) {
                                        return r[0].percent;
                                    }

                                    return 0;
                                }),
                                backgroundColor: colors[idx],
                                hoverOffset: 4
                            };
                        })
                    }
                };
            })
        }
    });

}

export const QuestionCharts = () : JSX.Element => {
    const colors = [...(new Array(100))].map(() => {
        return generateRandomRgb();
    });

    const [data,] = React.useContext(ChartDataContext);
    const [questionsData,setQuestionsData] = React.useState(convertResultsetToChartData(data,colors));

    React.useEffect(() => {
        if(!data.fetching&&!data.fetch){
            setQuestionsData(convertResultsetToChartData(data,colors))
        }
    },[data]);

    const options = {
        scales: {
            x: {
                stacked: true,
                minBarLength: 2,
                gridLines: {
                    offsetGridLines: true
                },
                ticks: {
                    autoSkip: false,
                    font: {
                        size: 10
                    },
                    callback: (value, index) => {
                        return `${index+1}`;
                    }
                }
            },
            y: {
                stacked: true,
                ticks: {
                    max: 100,
                    min: 0,
                    stepSize: 10
                }
            }
        },
        plugins: {
            legend: {
                display: true,
                position: 'right' as any
            },
            tooltips: {
                callbacks: {
                    title: function(tooltipItem, data) {
                        const sentence = data.labels[tooltipItem[0].index];

                        let maxLen: number = 50;
                        let rows: Array<string> = [];
                        let line: Array<string> = [];

                        sentence.split(' ').map((word) => {
                            if((line.join(' ') + word).length <= maxLen) {
                                line.push(word);
                            } else {
                                rows.push(line.join(' '));
                                line = [];
                            }
                        });
                        rows.push(line.join(' '));

                        return rows;
                    }
                }
            }
        }
    };

    return <div className={'c-rstats__charts'}>
        <h2>Resultaten vragen</h2>
        { questionsData.map((data,index) => {
            return <div key={`questiondata_${index}`}>
                <h3>Vragen bij {data.label}</h3>
                { data.result_set.map((rs,rs_idx) => {
                    return <BarChart key={`questiondata_rs_${index}_${rs_idx}`} data={rs.dataset} options={options} label={`Vragen bij ${rs.chapter}`}/>
                })}
            </div>
        })}
    </div>;
}
